import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Flex,
  Radio,
  Select,
  InputNumber,
  InputNumberProps,
  Row,
  Col,
  Space,
  Tag,
} from "antd";

import TextArea from "antd/es/input/TextArea";
import { Device } from "../../../types/device";
import { Function } from "../../../types/function";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { removeDiacriticsAndLowercase } from "../../../ultils/helpers";

interface FunctionFormProps {
  initialValues: Function;
  onSubmit: (values: Function) => void;
  open: boolean;
  checkDpIdExists: (dpId: number, initDpIp?: number) => boolean;
}

const FunctionForm: React.FC<FunctionFormProps> = ({
  initialValues,
  onSubmit,
  open,
  checkDpIdExists,
}) => {
  const [form] = Form.useForm();
  const [dataType, setDataType] = useState<string>(initialValues.data_type);

  const onChangeDataType = (value: string) => {
    setDataType(value);
  };
  const [inputValue, setInputValue] = useState(""); // Quản lý giá trị nhập liệu tạm thời
  // Xử lý khi giá trị trong input thay đổi
  const handleInputChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setInputValue(e.target.value);
  };

  // Xử lý khi xác nhận thêm giá trị (nhấn Enter hoặc click nút "Thêm")
  const handleInputConfirm = () => {
    if (inputValue && inputValue.trim() !== "") {
      const newValue = inputValue.trim();
      const newKey = removeDiacriticsAndLowercase(newValue);
      const newItem = { key: newKey, value: newValue };
      const currentValues = form.getFieldValue("enumerated_value") || [];
      form.setFieldsValue({
        enumerated_value: [...currentValues, newItem],
      });

      setInputValue("");
    }
  };
  const handleSubmitFailed = () => {
  };
  useEffect(() => {
    if (open) {
      form.resetFields();
      if (initialValues._id) {
        form.setFieldsValue(initialValues);
        setDataType(initialValues.data_type);
        if (initialValues.data_type == "Value") {
          form.setFieldsValue({
            ...initialValues,
            data_type: initialValues.data_type,
            pitch: initialValues.function_type_detail.pitch,
            scale: initialValues.function_type_detail.scale,
            unit: initialValues.function_type_detail.unit,
            value_range_min: initialValues.function_type_detail.value_range_min,
            value_range_max: initialValues.function_type_detail.value_range_max,
          });
        } else if (initialValues.data_type == "Enum") {
          form.setFieldsValue({
            ...initialValues,
            enumerated_value:
              initialValues.function_type_detail.enumerated_value,
          });
        } else if (
          initialValues.data_type == "Double" ||
          initialValues.data_type == "Float"
        ) {
        } else if (initialValues.data_type == "String") {
          form.setFieldsValue({
            ...initialValues,
            string_value: initialValues.function_type_detail.string_value,
          });
        }
        else if (initialValues.data_type == "Fault") {
          form.setFieldsValue({
            ...initialValues,
            err_detail: initialValues.function_type_detail.err_detail,
          });
        }
      } else {
        form.resetFields();
        form.setFieldsValue(initialValues);
        setDataType(initialValues.data_type);
      }
    }
  }, [initialValues, form, open]);
  return (
    <Form
      form={form}
      onFinish={onSubmit}
      onFinishFailed={handleSubmitFailed}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 17 }}
    >
      <Form.Item
        name="dp_id"
        label="DP ID"
        rules={[
          {
            required: true,
            message: "Vui lòng không để trống DP ID",
          },
          {
            type: "number",
            min: 1,
            max: 255,
            message: "DP ID phải từ 1 đến 255",
          },
          {
            validator: (_, value) => {
              const exists = checkDpIdExists(value, initialValues.dp_id);
              if (exists && value !== initialValues.dp_id) {
                return Promise.reject(new Error("DP ID đã tồn tại"));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <InputNumber min={1} max={255} style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item
        name="function_name"
        label="Function Name"
        rules={[
          {
            required: true,
            message: "Vui lòng không để trống tên function",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="indentifier"
        label="Indentifier"
        rules={[
          {
            required: true,
            message: "Vui lòng không để trống indentifier",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item label="Function type" name="function_type_name">
        <Radio.Group defaultValue={"Property"}>
          <Radio.Button value="Property">Property</Radio.Button>
          <Radio.Button value="Event">Event</Radio.Button>
          <Radio.Button value="Action">Action</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name="data_type"
        label="Data type"
        rules={[
          {
            required: true,
            message: "Vui lòng chọn Data type!",
          },
        ]}
      >
        <Select
          placeholder="Data type"
          optionFilterProp="label"
          onChange={onChangeDataType}
          defaultValue={dataType}
          options={[
            {
              value: "Value",
              label: "Value",
            },
            {
              value: "Float",
              label: "Float",
            },
            {
              value: "Double",
              label: "Double",
            },
            {
              value: "Enum",
              label: "Enum",
            },
            {
              value: "String",
              label: "String",
            },
            {
              value: "Date",
              label: "Date",
            },
            {
              value: "Bool",
              label: "Bool",
            },
            {
              value: "Raw",
              label: "Raw",
            },
            {
              value: "Array",
              label: "Array",
            },
            {
              value: "Fault",
              label: "Fault",
            },
          ]}
        />
      </Form.Item>
      {dataType === "Value" && (
        <>
          <Form.Item
            label="Value Range"
            rules={[
              {
                validator: (_, value, callback) => {
                  const min = form.getFieldValue("value_range_min");
                  const max = form.getFieldValue("value_range_max");
                  if (min === undefined || min === null || min === "") {
                    callback("Vui lòng nhập giá trị Min");
                  } else if (max === undefined || max === null || max === "") {
                    callback("Vui lòng nhập giá trị Max");
                  } else if (isNaN(Number(min)) || isNaN(Number(max))) {
                    callback("Giá trị phải là số hợp lệ");
                  } else if (Number(min) >= Number(max)) {
                    callback("Giá trị tối thiểu phải nhỏ hơn giá trị tối đa");
                  } else {
                    callback(); // Không có lỗi
                  }
                },
              },
            ]}
          >
            <Space.Compact style={{ width: "100%" }}>
              <Form.Item name="value_range_min" noStyle>
                <InputNumber style={{ width: "50%" }} placeholder="Min" />
              </Form.Item>
              <Form.Item name="value_range_max" noStyle>
                <InputNumber style={{ width: "50%" }} placeholder="Max" />
              </Form.Item>
            </Space.Compact>
          </Form.Item>
          <Form.Item
            name="pitch"
            label="Pitch"
            rules={[
              {
                required: true,
                message: "Vui lòng không để trống tên Pitch",
              },
            ]}
          >
            <InputNumber style={{ width: "150px" }} />
          </Form.Item>
          <Form.Item
            name="scale"
            label="Scale"
            rules={[
              {
                required: true,
                message: "Vui lòng không để trống tên scale",
              },
            ]}
          >
            <InputNumber min={0} style={{ width: "150px" }} />
          </Form.Item>
          <Form.Item
            name="unit"
            label="Unit"
            rules={[
              {
                required: true,
                message: "Vui lòng không để trống tên unit",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </>
      )}
      {(dataType === "Double" || dataType === "Float") && (
        <>
          <Form.Item
            label="Value Range"
            name="value_range"
            rules={[
              {
                validator: (_, value, callback) => {
                  const min = form.getFieldValue("value_range_min");
                  const max = form.getFieldValue("value_range_max");
                  if (min === undefined || min === null || min === "") {
                    callback("Vui lòng nhập giá trị Min");
                  } else if (max === undefined || max === null || max === "") {
                    callback("Vui lòng nhập giá trị Max");
                  } else if (isNaN(Number(min)) || isNaN(Number(max))) {
                    callback("Giá trị phải là số hợp lệ");
                  } else if (Number(min) >= Number(max)) {
                    callback("Giá trị tối thiểu phải nhỏ hơn giá trị tối đa");
                  } else {
                    callback(); // Không có lỗi
                  }
                },
              },
            ]}
          >
            <Space.Compact style={{ width: "100%" }}>
              <Form.Item name="value_range_min" noStyle>
                <InputNumber style={{ width: "50%" }} placeholder="Min" />
              </Form.Item>
              <Form.Item name="value_range_max" noStyle>
                <InputNumber style={{ width: "50%" }} placeholder="Max" />
              </Form.Item>
            </Space.Compact>
          </Form.Item>
          <Form.Item
            name="pitch"
            label="Pitch"
            rules={[
              {
                required: true,
                message: "Vui lòng không để trống tên Pitch",
              },
            ]}
          >
            <InputNumber style={{ width: "150px" }} />
          </Form.Item>
          <Form.Item
            name="unit"
            label="Unit"
            rules={[
              {
                required: true,
                message: "Vui lòng không để trống tên unit",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </>
      )}
      {dataType === "String" && (
        <>
          <Form.Item
            name="string_value"
            label="Value"
            rules={[
              {
                required: true,
                message: "Vui lòng không để trống tên String value",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </>
      )}
      {dataType === "Fault" && (
        <>
          <Form.Item
            name="err_detail"
            label="Error details"
            rules={[
              {
                required: true,
                message: "Vui lòng không để trống",
              },
            ]}
          >
            <TextArea />
          </Form.Item>
        </>
      )}

      {dataType === "Enum" && (
        <>
          <Form.Item label="Enum value" required>
            <Form.List
              name="enumerated_value"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || value.length === 0) {
                      return Promise.reject(
                        new Error("Enum value không được để trống!")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              {(fields, { remove }, { errors }) => (
                <>
                  <Space
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      marginBottom: 8,
                    }}
                  >
                    {fields.map((field) => (
                      <Tag
                        key={field.key}
                        closable
                        onClose={() => remove(field.name)}
                      >
                        {form.getFieldValue([
                          "enumerated_value",
                          field.name,
                          "value",
                        ])}
                      </Tag>
                    ))}
                  </Space>

                  <Space>
                    <Input
                      placeholder="Nhập giá trị mới"
                      value={inputValue}
                      onChange={handleInputChange}
                      onPressEnter={handleInputConfirm}
                    />
                    <Button
                      type="dashed"
                      onClick={handleInputConfirm}
                      icon={<PlusOutlined />}
                    >
                      Thêm
                    </Button>
                  </Space>
                  <div style={{ color: "red", marginBottom: 8 }}>
                    <Form.ErrorList errors={errors} />
                  </div>
                </>
              )}
            </Form.List>
          </Form.Item>
        </>
      )}
      <Form.Item label="Device transfer type" name="data_transfer_type">
        <Flex vertical gap="small">
          <Radio.Group
            defaultValue={initialValues.data_transfer_type}
            options={[
              {
                value: "Send and Report",
                label: "Send and Report",
              },
              {
                value: "Report Only",
                label: "Report Only",
              },
              {
                value: "Send Only",
                label: "Send Only",
              },
            ]}
          />
        </Flex>
      </Form.Item>

      <Form.Item label="Remark" name="remark">
        <TextArea />
      </Form.Item>
      <Form.Item
        name="display_type"
        label="Display type"
        rules={[
          {
            required: true,
            message: "Vui lòng chọn Data type!",
          },
        ]}
      >
        <Select
          optionFilterProp="label"
          defaultValue={"Not Display"}
          options={[
            {
              value: "Not Display",
              label: "Not Display",
            },
            {
              value: "Info Display",
              label: "Info Display",
            },
            {
              value: "Setting Display",
              label: "Setting Display",
            },
          ]}
        />
      </Form.Item>
      <Form.Item label={null}>
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => form.validateFields()}
        >
          Lưu
        </Button>
      </Form.Item>
    </Form>
  );
};

export default FunctionForm;
